module.exports = __webpack_public_path__ + "v1.0.0/img/nodata.206b0d9.png";


//////////////////
// WEBPACK FOOTER
// ./src/style/images/nodata.png
// module id = baTq
// module chunks = 1